export default {
  NOT_STARTED: 'NOT_STARTED',
  REVISED: 'REVISED',
  COMPLETED: 'COMPLETED',
};
